<template>
  <div id="modalDidtributor" class="modal fade">
    <div
      class="modal-dialog modal-dialog-vertical-center modal-lg"
      role="document"
      :class="{ 'modal-max': max }"
    >
      <div class="modal-content bd-0 tx-14">
        <modal-loading :show="loading"></modal-loading>
        <div class="modal-header pd-y-20 pd-x-25">
          <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">
            {{
              changeinfo
                ? $t("distributor.修改合作客户")
                : $t("distributor.新增合作客户")
            }}
          </h6>
          <div>
            <button type="button" class="size" @click="changeSize">
              <i
                class="fa"
                :class="max ? 'fa-window-restore' : 'fa-window-maximize'"
              ></i>
            </button>
            <button
              type="button"
              data-dismiss="modal"
              aria-label="Close"
              class="close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
        </div>
        <div
          class="modal-body pd-25"
          :style="{ maxHeight: max ? maxH + 'px' : '460px' }"
        >
          <form>
            <div class="form-group row">
              <label
                for="iptTargetType"
                class="
                  col-md-2 col-sm-12 col-form-label
                  form-control-sm
                  text-right
                "
              >
                <span class="tx-danger">*</span
                >{{ $t("distributor.客户名称：") }}
              </label>
              <div class="col-md-10 col-sm-12">
                <input
                  type="text"
                  :placeholder="$t('distributor.请输入客户名称')"
                  name="name"
                  id="name"
                  class="form-control form-control-sm"
                  v-model="name"
                />
              </div>
            </div>
            <div class="form-group row">
              <label
                for="iptTargetType"
                class="
                  col-md-2 col-sm-12 col-form-label
                  form-control-sm
                  text-right
                "
              >
                <span class="tx-danger">*</span>{{ $t("distributor.联系人：") }}
              </label>
              <div class="col-md-4 col-sm-12">
                <input
                  type="text"
                  :placeholder="$t('distributor.请输入联系人')"
                  name="addressContact"
                  id="addressContact"
                  class="form-control form-control-sm"
                  v-model="contact"
                />
              </div>
              <label
                for="iptTargetType"
                class="
                  col-md-2 col-sm-12 col-form-label
                  form-control-sm
                  text-right
                "
              >
                {{ $t("distributor.手机：") }}
              </label>
              <div class="col-md-4 col-sm-12">
                <input
                  type="text"
                  :placeholder="$t('distributor.请输入联系人手机')"
                  name="newMobile"
                  id="newMobile"
                  class="form-control form-control-sm"
                  v-model="mobile"
                />
              </div>
            </div>
            <div class="form-group row">
              <label
                for="iptTargetType"
                class="
                  col-md-2 col-sm-12 col-form-label
                  form-control-sm
                  text-right
                "
              >
                QQ：
              </label>
              <div class="col-md-4 col-sm-12">
                <input
                  type="text"
                  :placeholder="$t('distributor.请输入联系人QQ')"
                  name="addressqq"
                  id="newQq"
                  class="form-control form-control-sm"
                  v-model="qq"
                />
              </div>
              <label
                for="iptTargetType"
                class="
                  col-md-2 col-sm-12 col-form-label
                  form-control-sm
                  text-right
                "
              >
                {{ $t("distributor.邮箱：") }}
              </label>
              <div class="col-md-4 col-sm-12">
                <input
                  type="text"
                  :placeholder="$t('distributor.请输入联系人邮箱')"
                  name="addressEmail"
                  id="newEmail"
                  class="form-control form-control-sm"
                  v-model="email"
                />
              </div>
            </div>
            <div class="form-group row">
              <label
                for="iptTargetType"
                class="
                  col-md-2 col-sm-12 col-form-label
                  form-control-sm
                  text-right
                "
              >
                {{ $t("distributor.省/市/区：") }}
              </label>
              <div class="col-md-10 col-sm-12 row">
                <div class="col">
                  <select
                    class="form-control form-control-sm"
                    @change="selectProvince()"
                    v-model="province"
                    name="addressProvince"
                  >
                    <option
                      v-for="(province, index) in selectCityArr"
                      :key="index"
                      v-text="province.name"
                      :value="index"
                    ></option>
                  </select>
                </div>
                <div class="col">
                  <select
                    class="form-control form-control-sm"
                    @change="selectCity()"
                    v-model="city"
                    :disabled="cityArr.length < 1"
                    name="addressCity"
                  >
                    <option
                      v-for="(city, index) in cityArr"
                      :key="index"
                      v-text="city.name"
                      :value="index"
                    ></option>
                  </select>
                </div>
                <div class="col">
                  <select
                    class="form-control form-control-sm"
                    v-model="area"
                    :disabled="areaArr.length < 1"
                    name="addressArea"
                  >
                    <option
                      v-for="(area, index) in areaArr"
                      :key="index"
                      v-text="area.name"
                      :value="index"
                    ></option>
                  </select>
                </div>
              </div>
            </div>
            <div class="form-group row">
              <label
                for="iptTargetType"
                class="
                  col-md-2 col-sm-12 col-form-label
                  form-control-sm
                  text-right
                "
              >
                {{ $t("distributor.详细地址：") }}
              </label>
              <div class="col-md-10 col-sm-12">
                <input
                  type="text"
                  :placeholder="$t('distributor.请输入详细地址')"
                  name="addressDetail"
                  id="addressDetail"
                  class="form-control form-control-sm"
                  v-model="address"
                />
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="
              btn btn-primary
              tx-11 tx-uppercase
              pd-y-12 pd-x-25
              tx-mont tx-semibold
            "
            @click="save"
          >
            {{ $t("distributor.保存") }}
          </button>
          <button
            type="button"
            class="
              btn btn-secondary
              tx-11 tx-uppercase
              pd-y-12 pd-x-25
              tx-mont tx-semibold
            "
            data-dismiss="modal"
          >
            {{ $t("distributor.取消") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["open", "changeinfo"],
  data() {
    return {
      max: false,
      maxH: 460,
      loading: false,
      province: "",
      city: "",
      area: "",
      address: "",
      mobile: "",
      selectCityArr: arrCity,
      cityArr: [],
      areaArr: [],
      name: "",
      email: "",
      qq: "",
      contact: "",
    };
  },
  mounted() {
    $("#modalDidtributor").on("shown.bs.modal", () => {
      this.sizeHeight();
      $(window).on("resize", () => {
        this.sizeHeight();
      });
    });
    $("#modalDidtributor").on("hide.bs.modal", () => {
      $(window).off("resize");
    });
  },
  watch: {
    open: function () {
      this.resetModal();
    },
  },
  methods: {
    sizeHeight() {
      let wH = $(window).height(),
        hH = $("#modalDidtributor .modal-header").height(),
        fH = $("#modalDidtributor .modal-footer").height();
      this.maxH = wH - hH - fH - 160;
    },
    changeSize() {
      this.max = !this.max;
      $("#modalDidtributor .modal-dialog").removeAttr("style");
    },
    resetModal() {
      this.cityArr = [];
      this.areaArr = [];
      if (this.changeinfo.province) {
        //选省
        for (let i = 0; i < this.selectCityArr.length; i++) {
          if (this.selectCityArr[i].name == this.changeinfo.province) {
            this.province = i;
            this.selectProvince();
            break;
          }
        }
      } else {
        this.province = 0;
      }

      if (this.changeinfo.city) {
        //选市
        for (let i = 0; i < this.cityArr.length; i++) {
          if (this.cityArr[i].name == this.changeinfo.city) {
            this.city = i;
            if (i > 0) this.selectCity();
            break;
          }
        }
      } else {
        this.city = 0;
      }

      if (this.changeinfo.area) {
        //选区
        for (let i = 0; i < this.areaArr.length; i++) {
          if (this.areaArr[i].name == this.changeinfo.area) {
            this.area = i;
            break;
          }
        }
      } else {
        this.area = undefined;
      }
      this.address = this.changeinfo.address;
      this.mobile = this.changeinfo.phone;
      this.name = this.changeinfo.name;
      this.email = this.changeinfo.email;
      this.qq = this.changeinfo.qq;
      this.contact = this.changeinfo.contacts;
    },
    save() {
      let form = $("#modalDidtributor form");
      form.validate({
        rules: {
          name: {
            required: true,
          },
          addressContact: {
            required: true,
          },
        },
        messages: {
          name: {
            required: this.$t("distributor.必须输入"),
          },
          addressContact: {
            required: this.$t("distributor.必须输入"),
          },
        },
        ignore: "",
        errorElement: "span",
        errorClass: "ipt-error",
        errorPlacement: function (error, element) {
          let nextEl = $(element).next();
          if (nextEl.length) {
            $(element).parent().append(error);
          } else {
            error.insertAfter(element);
          }
        },
      });

      let param = {
        province: this.province
          ? this.selectCityArr[this.province].name
          : undefined, //省份
        city: this.city ? this.cityArr[this.city].name : undefined, //城市
        area:
          this.area || this.area === 0
            ? this.areaArr[this.area].name
            : undefined, //区域
        name: this.name,
        address: this.address,
        phone: this.mobile,
        email: this.email,
        qq: this.qq,
        contacts: this.contact,
      };
      if (form.valid()) {
        if (this.changeinfo.id) {
          param.id = this.changeinfo.id;
          this.editRawSupplier(param);
        } else {
          this.createRawSupplier(param);
        }
      }
    },
    // 创建供应商信息
    createRawSupplier(param) {
      this.loading = true;
      $.api_call("api.SupplierProductStock.createRawSupplier", param, (r) => {
        this.loading = false;
        if (r.ErrorCode == "9999") {
          ShowTip(this.$t("distributor.新增客户成功"), "success");
          $("#modalDidtributor").modal("hide");
          this.$parent.getDistributor();
        } else {
          ShowTip(r.Message, "danger");
        }
      });
    },
    // 修改供应商信息
    editRawSupplier(param) {
      this.loading = true;
      $.api_call("api.SupplierProductStock.editRawSupplier", param, (r) => {
        this.loading = false;
        if (r.ErrorCode == "9999") {
          ShowTip(this.$t("distributor.修改客户成功"), "success");
          $("#modalDidtributor").modal("hide");
          this.$parent.getDistributor();
        } else {
          ShowTip(r.Message, "danger");
        }
      });
    },
    selectProvince() {
      this.city = 0;
      this.area = undefined;
      this.cityArr = [];
      this.areaArr = [];
      let p = this.province;
      if (this.selectCityArr[p] && this.selectCityArr[p].sub) {
        this.cityArr = this.selectCityArr[p].sub;
      } else {
        this.cityArr = [];
      }
    },
    selectCity() {
      this.area = undefined;
      let c = this.city;
      if (!c) return;
      if (this.cityArr[c].sub) {
        this.areaArr = this.cityArr[c].sub;
      } else {
        this.areaArr = [];
      }
    },
  },
};
</script>
